export default class UpdateApplicationStatusModel {
  Status?: number
}
